export default function Features() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: '智能数据归集',
      description: '自动采集企业各类研发数据，支持多系统对接，实现数据实时同步，告别手工录入',
      color: 'from-teal-500 to-teal-600',
      bgColor: 'bg-teal-50',
      iconBg: 'bg-gradient-to-br from-teal-500 to-teal-600'
    },
    {
      icon: 'ri-calculator-line',
      title: '精准费用核算',
      description: '智能识别研发费用类别，自动计算加计扣除金额，确保核算准确无误',
      color: 'from-cyan-500 to-cyan-600',
      bgColor: 'bg-cyan-50',
      iconBg: 'bg-gradient-to-br from-cyan-500 to-cyan-600'
    },
    {
      icon: 'ri-file-chart-line',
      title: '一键生成报表',
      description: '支持多种报表格式，满足税务申报、高新认定等不同场景需求，一键导出',
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
      iconBg: 'bg-gradient-to-br from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: '合规风险预警',
      description: '实时监控研发费用合规性，智能识别潜在风险，提前预警避免损失',
      color: 'from-teal-600 to-cyan-600',
      bgColor: 'bg-teal-50',
      iconBg: 'bg-gradient-to-br from-teal-600 to-cyan-600'
    },
    {
      icon: 'ri-team-line',
      title: '项目全程管理',
      description: '从立项到结项全流程管理，支持多项目并行，实时掌握项目进度和成本',
      color: 'from-cyan-600 to-blue-600',
      bgColor: 'bg-cyan-50',
      iconBg: 'bg-gradient-to-br from-cyan-600 to-blue-600'
    },
    {
      icon: 'ri-cloud-line',
      title: '云端安全存储',
      description: '采用银行级加密技术，数据云端存储，支持多终端访问，安全可靠',
      color: 'from-blue-600 to-teal-600',
      bgColor: 'bg-blue-50',
      iconBg: 'bg-gradient-to-br from-blue-600 to-teal-600'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-gray-50/50 to-white relative overflow-hidden">
      {/* 装饰背景 */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-br from-teal-100/40 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-blue-100/40 to-transparent rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        {/* 标题区域 */}
        <div className="text-center mb-20 animate-fade-in">
          <div className="inline-flex items-center bg-gradient-to-r from-teal-500/10 to-blue-500/10 border border-teal-200 text-teal-700 px-6 py-2 rounded-full text-sm font-bold mb-6">
            <i className="ri-star-line mr-2"></i>
            核心功能
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6">
            强大功能，<span className="bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">助力企业发展</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            智研云提供全方位的研发费用管理解决方案，让复杂的研发费用管理变得简单高效
          </p>
        </div>

        {/* 功能卡片网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-teal-200 hover:-translate-y-2 cursor-pointer overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* 悬停背景效果 */}
              <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
              {/* 装饰圆圈 */}
              <div className={`absolute -top-10 -right-10 w-32 h-32 bg-gradient-to-br ${feature.color} opacity-5 rounded-full group-hover:scale-150 transition-transform duration-700`}></div>

              <div className="relative z-10">
                {/* 图标 */}
                <div className={`w-16 h-16 ${feature.iconBg} rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>

                {/* 标题 */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-teal-600 transition-colors">
                  {feature.title}
                </h3>

                {/* 描述 */}
                <p className="text-gray-600 leading-relaxed text-base">
                  {feature.description}
                </p>

                {/* 了解更多箭头 */}
                <div className="mt-6 flex items-center text-teal-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="text-sm mr-2">了解更多</span>
                  <i className="ri-arrow-right-line text-lg group-hover:translate-x-2 transition-transform duration-500"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
